import { computed, } from '@vue/composition-api';
import isEmpty from 'lodash.isempty';
import { getSinglePlace } from '@/api/requests/places';
import { usePlaceResourcesStore } from '@/store/place-resources';
import { useObjectResourcesStore } from '@/store/object-resources';
import { SelectionMode } from '@/store/_composables/use-resources';
import { mapId } from '@/util/common';
import { useUpdatesCounter } from '@/composables/use-updates-counter';
export const useObjectListActions = (props, ctx) => {
    const { selectedEntries } = props;
    const { update, updatesCounter } = useUpdatesCounter();
    const getPlacesToSelect = async () => {
        const placeIds = [];
        selectedEntries.value.forEach((object) => {
            const placeId = object.place?.id;
            if (placeId && !placeIds.includes(placeId))
                placeIds.push(placeId);
        });
        return Promise.all(placeIds.map(getSinglePlace));
    };
    const openAddReport = async () => {
        const placesToSelect = await getPlacesToSelect();
        const { onPlaceSelection, setPlaceSelectionMode } = usePlaceResourcesStore();
        const { onObjectSelection, setObjectSelectionMode } = useObjectResourcesStore();
        setPlaceSelectionMode(SelectionMode.INSTANT);
        onPlaceSelection(mapId(placesToSelect), placesToSelect);
        setPlaceSelectionMode(SelectionMode.DELAYED);
        setObjectSelectionMode(SelectionMode.INSTANT);
        onObjectSelection(mapId(selectedEntries.value), selectedEntries.value);
        setObjectSelectionMode(SelectionMode.DELAYED);
        ctx.root.$router.push({
            name: 'Reports',
            params: {
                addReport: true,
            },
        });
    };
    const rawObjectsListsActions = computed(() => {
        return {
            createTask: {
                name: ctx.root.$t('brand-places-list-view.create-report'),
                disabled: isEmpty(selectedEntries.value),
                handler: openAddReport,
            },
        };
    });
    return {
        updatesCounter,
        update,
        objectsListsActions: rawObjectsListsActions,
    };
};
